import React from "react";
import {changeBurger, usePanel} from "../../../../redux/reducer/panel";
import {useDispatch} from "react-redux";
import stylesCH from "../../gui/customHeader/CustomHeader.module.scss";
import classNames from "classnames";

export default function HeaderBurger() {
  const dispatch = useDispatch();
  const {burger} = usePanel();

  return (
    <label htmlFor={"menu-burger"}
           className={classNames('header__burger', stylesCH.customHeader__burger)}
           onClick={()=> dispatch(changeBurger(!burger))}
    >
      <p/>
      <p/>
      <p/>
    </label>
  )
}
